import { Box, Button, Typography } from "@mui/material";

interface Props {
  onClose: () => void;
}

export function PaymentIntentPresentError({ onClose }: Props) {
  return (
    <Box>
      <Typography variant="body2">
        Payment for this policy is already being processed. Please wait up to 15
        minutes and check the policy list. If the policy does not appear after
        15 minutes, please contact <b>agentservice@covertree.com</b> for
        assistance.
      </Typography>
      <Box mt={4}>
        <Button onClick={onClose}>Close</Button>
      </Box>
    </Box>
  );
}
